import PubsubHandler from "../pubsub/pubsub-event-handler";
import { logAddToCartFail, logAddToCart } from "../analytics";
import { updateHeaderBadge } from "../utils/cart";
const { translate, fetchTranslationFromPhrase } = require("../utils/translate");
const { getCartId } = require("../utils/cart");

const NAMESPACE_CART = "CART_CLIENT";

const events = {
  ADD_TO_CART: "ADD_TO_CART",
  ADD_TO_CART_INITIATE: "ADD_TO_CART_INITIATE",
  ADD_TO_CART_SUCCESS: "ADD_TO_CART_SUCCESS",
  ADD_TO_CART_FAIL: "ADD_TO_CART_FAIL",
};

const cartPubsub = PubsubHandler(NAMESPACE_CART);

const addToCartInternalstatusCodes = {
  CART_ADD_SUCCESS: "CART_ADD_SUCCESS",
  CART_ADD_FAIL: "CART_ADD_FAIL",
};

const initPurchaseHandler = (rangePurchaseHandler) => {
  cartPubsub.subscribe(events.ADD_TO_CART, async (event = {}) => {
    if (
      window.ikea &&
      window.ikea.shoppingCart &&
      window.ikea.shoppingCart.agentLoaded
    ) {
      return;
    }
    await fetchTranslationFromPhrase();
    // TODO: validate event data
    if (
      !event.items ||
      !event.items[0] ||
      !event.items[0].productNumber ||
      !event.items[0].productType
    ) {
      const errorMessage = new Error("productNumber or productType is missing");
      logAddToCartFail({ errorMessage });
      cartPubsub.publish(
        events.ADD_TO_CART_FAIL,
        Object.assign({ errorMessage }, event, { skipToast: true })
      );
      window?.ikea?.toast(
        translate('add_to_cart_failure_toast'),
        null,
        null
      )
      return;
    }

    cartPubsub.publish(events.ADD_TO_CART_INITIATE, event);
    const items = event.items;
    rangePurchaseHandler
      .addToCart(items)
      .then((res) => {
        if (res.status === addToCartInternalstatusCodes.CART_ADD_SUCCESS) {
          // Send cart ID as a custom dimension only if it's OW cart
          if (res.cart) {
            event = {
              ...event,
              custom: {
                ...event.custom,
                cart_id: getCartId(res.cart),
              },
            };
          }
          // TODO:
          // remove if statement when ignoreGa is no longer needed
          if (!(event.ignoreGa && event.ignoreGa === true)) {
            logAddToCart(event, items);
          }
          updateHeaderBadge(items);
          cartPubsub.publish(
            events.ADD_TO_CART_SUCCESS,
            Object.assign({}, event, res, { skipToast: true })
          );
          // In-case pip events do not display toast and recommendations takes care to display modal
          event?.source !== 'pip' && window?.ikea?.toast(
            translate('add_to_cart_success_toast', {
              productName: items.map(item => item.productName).join(', ')
            }),
            { label: translate('show'), callbackOrHref: CONFIG.shoppingcartUrl },
            null
          )
        } else {
          logAddToCartFail(res && res.error);
          cartPubsub.publish(
            events.ADD_TO_CART_FAIL,
            Object.assign({}, event, { errorMessage: res && res.error }, { skipToast: true })
          );
          window?.ikea?.toast(
            translate('add_to_cart_failure_toast'),
            null,
            null
          );
        }
      })
      .catch((errorMessage) => {
        logAddToCartFail(errorMessage);
        cartPubsub.publish(
          events.ADD_TO_CART_FAIL,
          Object.assign({ errorMessage }, event, { skipToast: true })
        );
        window?.ikea?.toast(
          translate('add_to_cart_failure_toast'),
          null,
          null
        );
      });
  });
};

export default initPurchaseHandler;
